import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Vant from "vant";
import "vant/lib/index.css";
import VueClipboard from "vue-clipboard2";
import "@/assets/css/safe.scss";
import Panel from "./components/Panel.vue";
import highlight from "@/plugins/highlight";
import katex from "@/plugins/katex";
import "katex/dist/katex.min.css";
import { previewImage } from "@/utils/globalImageViewer";
document.body.addEventListener("dblclick", (e) => {
  if (e.target.tagName === "IMG") {
    e.preventDefault();
    previewImage(e.target);
  }
});
import {
  stagePermission,
  stagePermission2,
  stagePermission3,
} from "./directives/stagePermission";
Vue.directive("stage-visible", stagePermission);
Vue.directive("studying-visible", stagePermission2);
Vue.directive("completion-visible", stagePermission3);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueClipboard);
Vue.use(highlight);
Vue.use(katex);
Vue.component(Panel.name, Panel);
Vue.config.errorHandler = function (err, vm, info) {
  console.error(`[Vue error]: ${err.toString()} \n ${info}`);
};
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
